/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputUavMissionStatus
 */
export interface InputUavMissionStatus {
    /**
     * KeepPosition — не скидати ручну корекцію позиції при зміні статусу. Потрібно для
     * авто-переходів анімації: черговий перетягнув борт за ЛБЗ, статус іде слідом,
     * і борт має лишитись саме там, куди його поставили, а не стрибнути на анкер.
     * @type {boolean}
     * @memberof InputUavMissionStatus
     */
    keepPosition?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InputUavMissionStatus
     */
    status: InputUavMissionStatusStatusEnum;
}


/**
 * @export
 */
export const InputUavMissionStatusStatusEnum = {
    AwaitingLaunch: 'awaiting_launch',
    AirborneOutbound: 'airborne_outbound',
    BeyondContactLine: 'beyond_contact_line',
    AirborneInbound: 'airborne_inbound',
    Landed: 'landed'
} as const;
export type InputUavMissionStatusStatusEnum = typeof InputUavMissionStatusStatusEnum[keyof typeof InputUavMissionStatusStatusEnum];


/**
 * Check if a given object implements the InputUavMissionStatus interface.
 */
export function instanceOfInputUavMissionStatus(value: object): boolean {
    if (!('status' in value)) return false;
    return true;
}

export function InputUavMissionStatusFromJSON(json: any): InputUavMissionStatus {
    return InputUavMissionStatusFromJSONTyped(json, false);
}

export function InputUavMissionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputUavMissionStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'keepPosition': json['keepPosition'] == null ? undefined : json['keepPosition'],
        'status': json['status'],
    };
}

export function InputUavMissionStatusToJSON(value?: InputUavMissionStatus | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'keepPosition': value['keepPosition'],
        'status': value['status'],
    };
}

